(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[197],{

/***/ 5464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _404; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/common/index.js + 178 modules
var common = __webpack_require__(981);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
;// CONCATENATED MODULE: ./styles/pages/ErrorPageStyle.js

var ErrorPageStyle = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs().withConfig({
  componentId: "sc-1ei2xgz-0"
})(["--animeMarg:var(--sp7x);--titleMarg:var(--sp4x);height:100vh;padding:var(--sp5x) var(--sp9x);.LottieWrapp{padding:15% 30%;margin-bottom:var(--animeMarg);}.title{margin-bottom:var(--titleMarg);}@media screen and (max-width:", ") and (min-width:", "){--animeMarg:var(--sp6x);--titleMarg:var(--sp4x);}@media screen and (max-width:", ") and (min-width:", "){--animeMarg:var(--sp5x);--titleMarg:var(--sp4x);}@media screen and (max-width:", "){--animeMarg:var(--sp4x);--titleMarg:var(--sp3x);.LottieWrapp{padding:20% 50%;}}@media screen and (max-width:", ") and (min-width:", "){--animeMarg:var(--sp4x);--titleMarg:var(--sp3x);.LottieWrapp{padding:20% 50%;}}@media screen and (max-width:", "){--animeMarg:var(--sp3x);--titleMarg:var(--sp2x);padding:var(--sp2x) var(--sp4x);.LottieWrapp{padding:25% 50%;}}"], function (props) {
  return props.theme.mediaQuery.DesktopSizeLMin;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeM;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeMMin;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeS;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeSMin;
}, function (props) {
  return props.theme.mediaQuery.LaptopSizeMin;
}, function (props) {
  return props.theme.mediaQuery.MobileSize;
}, function (props) {
  return props.theme.mediaQuery.TabletSizeMin;
});
/* harmony default export */ var pages_ErrorPageStyle = (ErrorPageStyle);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./pages/404.js





var NotFound = /*#__PURE__*/(0,react.memo)(function (props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(pages_ErrorPageStyle, {
    className: "FlexBoxColumn AlignMiddle AlignCenter",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(common/* Text */.xv, {
      tag: 'h3',
      className: 'title PolySansNeutralRegular grey',
      text: 'PageNotFound'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(common/* Button */.zx, {
      link: '/',
      className: 'purple',
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(common/* Title */.Dx, {
        type: 'btn',
        text: ['BackToHome'],
        fontSize: 'pL',
        className: 'whiteDark'
      })
    })]
  });
});
/* harmony default export */ var _404 = (NotFound);

/***/ }),

/***/ 2448:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(5464);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(2448); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);